import React from 'react';
import {
    Paper,
    Grid,
    Typography,
    FormControlLabel,
    FormGroup,
    Checkbox
} from 'material-ui';
import currencyFormatter from 'currency-formatter';
import Tooltip from 'material-ui/Tooltip';
import { withStyles } from 'material-ui/styles';
import { translate } from 'react-i18next';
import { netPrice } from '../../defaultValues/netPrice';
import getValue from '../../defaultValues/getValue';


function formatPrice(value) {
    return currencyFormatter.format(value, { code: 'EUR' });
}

function renderCancellations(pos, cancel, pvpFlag, netFlag, props) {
    if (cancel) {
        return (
            <li>
                {/*props.t('CONFIRM_BOOKING.BOOKING_CANCEL_TEXT', {cancelDate: cancel.date})*/}
                {props.t('CONFIRM_BOOKING.BOOKING_CANCEL_TEXT_PRE') + ' '}<b>{cancel.date.substring(0, 10)}</b>{' ' + props.t('CONFIRM_BOOKING.BOOKING_CANCEL_TEXT_POST') + ' '} &nbsp;
                {
                    pvpFlag ?
                        <Tooltip id="tooltip-icon" title={netFlag ? props.t('BOOKINGS.NET') + ': ' + formatPrice(cancel.cost) : ''}>
                            <b>{formatPrice(cancel.pvpCost)}</b>
                        </Tooltip>
                        :
                        <b>{formatPrice(cancel.cost)}</b>
                }
            </li>
        );
    } else {
        return '';
    }
}

const styles = theme => ({
    // root: theme.mixins.gutters({
    //   paddingTop: 16,
    //   paddingBottom: 16,
    //   marginTop: theme.spacing.unit * 3,
    // }),

    expandIcon: {
        color: theme.palette.primary.main
    },
    bookingTitle: {
        color: theme.palette.primary.main,
        padding: '20px 0 20px 25px',
        fontWeight: 'bold',
        fontSize: '1.2rem',
        borderLeft: '2px solid ' + theme.palette.primary.main
    },
    paperFrame: {
        margin: '15px 0px'
    }
});
/**
 * Componente que renderiza las opciones de cancelacion de una operacion
 */
class ReservationCancelDetailsRender extends React.Component {

    constructor(props) {
        super(props);

        this.currentUser = JSON.parse(localStorage.getItem('user'));

        this.state = {
            aceptoreservar: false,
            B2bVerPVP: this.currentUser.authorities.includes('B2bVerPVP')
        };
    }

    onCheck = (event, value) => {
        this.setState({ aceptoreservar: value });
        this.props.onCheck(value);
    };

    render() {
        const { reservation, classes, t, hasAssociatedTranfers } = this.props;
        const canceledReservation = reservation && reservation.state === 'C' || window.location.href.indexOf('view') !== -1;
        let cancelations = [];
        if (reservation !== undefined && reservation !== null) {
            cancelations = reservation.cancelations ? reservation.cancelations :
                [{ date: reservation.date, cost: reservation.cancelationFee }];
        }
        return (
            <Paper id="thepolicies" className={classes.paperFrame}>

                <Typography className={classes.bookingTitle}>
                    {t('CONFIRM_MODIFY_BOOKING.CANCELLATIONS_CONDITIONS')}
                </Typography>
                {hasAssociatedTranfers ?
                    <Grid container>
                        <Typography><b>{t('CONFIRM_MODIFY_BOOKING.WARN_RESERVATION_WITH_TRANSFERS')}</b></Typography>
                    </Grid> : ''}

                <Grid container>
                    <Grid item xs={12}>
                        <div>
                            {
                                cancelations.map((cancel, id) => {
                                    return cancel && cancel.roomRef ?
                                        <div key={id}>
                                            {id > 0 && cancelations[id - 1].order !== cancel.order ?
                                                <Typography>
                                                    {cancel.roomRef.service instanceof Object ? cancel.roomRef.service.description : cancel.roomRef.service}
                                                </Typography>
                                                :
                                                id === 0 ?
                                                    <Typography>
                                                        {cancel.roomRef.service instanceof Object ? cancel.roomRef.service.description : cancel.roomRef.service}
                                                    </Typography>
                                                    :
                                                    ''
                                            }
                                            <Typography component="ul">
                                                {renderCancellations(id,
                                                    cancel,
                                                    this.state.B2bVerPVP,
                                                    getValue(netPrice, this.currentUser.accountName.toLowerCase()),
                                                    this.props)
                                                }
                                            </Typography>
                                        </div> : '';
                                }
                                )
                            }
                        </div>
                        <Typography>
                            {
                                t('CONFIRM_MODIFY_BOOKING.PRICE_CALCULATION_MESSAGE')
                            }
                        </Typography>
                        <Typography component="small">{reservation && reservation.cancelationFeeMessage ? reservation.cancelationFeeMessage : ''}</Typography>
                        {!canceledReservation &&
                            <FormGroup row>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={this.state.aceptoreservar}
                                            onChange={this.onCheck}
                                            value="checkedA"
                                        />
                                    }
                                    label={t('CONFIRM_MODIFY_BOOKING.CANCELLATIONS_CONDITIONS_ACCEPT')}
                                />
                            </FormGroup>                            
                        } 
                    </Grid>
                </Grid>
            </Paper>
        );
    }
}
export default translate('translations')(withStyles(styles)(ReservationCancelDetailsRender));



// WEBPACK FOOTER //
// ./src/components/Reservation/ReservationCancelDetailsRender.js